<template>
  <div class="border-box-2" :ref="ref">
    <svg class="border-svg-container" :width="mergedWidth" :height="height">
      <defs>
        <linearGradient id="grad2" x1="100%" y1="50%" x2="10%" y2="100%">
          <stop offset="0" :stop-color="mergedColor[0]" stop-opacity="0.722"/>
          <stop offset="1" :stop-color="mergedColor[0]" stop-opacity="0"/>
        </linearGradient>
      </defs>
      <path :d="`M ${mergedWidth - 5} ${height / 3 - 20} L ${mergedWidth -5} 5 L 25 5 L 5 25 L 5 ${height - 5} L ${mergedWidth - 5} ${height - 5} L ${mergedWidth - 5} ${height / 3 + 20} L ${mergedWidth -15} ${height / 3 + 10} L ${mergedWidth -15} ${height / 3 -15}`" :fill="backgroundColor" :stroke="mergedColor[0]"/>
      <path :d="`M 28,7 l -20.954,20 v 7 l 27.938 -27 h 6 Z`" :fill="mergedColor[0]" fill-opacity="0.14" fill-rule="evenodd"/>
      <rect :x="`${mergedWidth - 16}`" :y="`${height / 3 - 16}`" width="2" height="2" rx="1" ry="1" :fill="mergedColor[0]" :stroke="mergedColor[0]"/>
      <path :d="`M ${(mergedWidth - 20) / 3  *2 } 5 L ${(mergedWidth - 20) / 3 * 2 +5} 5`" :stroke="backgroundColor"/>
      <!--<rect :x="`${(width -20) / 3 *2}`" y="4" width="2" height="2" rx="1" ry="1" :fill="mergedColor[0]" :stroke="mergedColor[0]"/>
      <rect :x="`${(width -20) / 3 *2 - 10}`" y="4" width="2" height="2" rx="1" ry="1" :fill="mergedColor[0]" :stroke="mergedColor[0]"/>-->

      <path :d="`M 20 5 L 5 5 L 5 20 L 20 5`" :fill="mergedColor[0]" :stroke="mergedColor[0]"/>
      <path :d="`M ${mergedWidth - 5} ${height -15} L ${mergedWidth -5} ${height -5} L ${mergedWidth -15} ${height -5}`" fill="transparent" stroke-width="2" :stroke="mergedColor[1]"/>
      <path :d="`M 5 ${height -15} L 5 ${height-5} L 15 ${height -5}`" fill="transparent" stroke-width="2" :stroke="mergedColor[1]"/>
      <g>
        <path :d="`M ${mergedWidth} ${height / 3 - 5} l -10 -8 v -4 l 10 8 v 4 Z`" fill="url(#grad2)"/>
        <path :d="`M ${mergedWidth} ${height / 3 - 5 + 8} l -10 -8 v -4 l 10 8 v 4 Z`" fill="url(#grad2)"/>
        <path :d="`M ${mergedWidth} ${height / 3 - 5 + 16} l -10 -8 v -4 l 10 8 v 4 Z`" fill="url(#grad2)"/>
        <path :d="`M ${mergedWidth} ${height / 3 - 5 + 24} l -10 -8 v -4 l 10 8 v 4 Z`" fill="url(#grad2)"/>
      </g>
    </svg>
    <div class="border-box-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import autoResize from '@jiaminghi/data-view/src/mixin/autoResize'
import { deepMerge } from '@jiaminghi/charts/lib/util/index'
import { deepClone } from '@jiaminghi/c-render/lib/plugin/util'

export default {
  name: 'BorderBox2',
  mixins: [autoResize],
  props: {
    color:{
      type:Array,
      default:()=>([])
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    },
    boxWidth: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      ref:'border-box-2',
      defaultColor: ['#00d4ff','#2cf7fe'],
      mergedColor: [],
      mergedWidth: 0,
    }
  },
  methods: {
    mergeColor() {
      const {color, defaultColor} = this
      this.mergedColor = deepMerge(deepClone(defaultColor, true), color || [])
    }
  },
  watch: {
    color() {
      const {mergeColor} = this
      mergeColor()
    },
    width: {
      deep: true,
      immediate: true,
      handler(value) {
        if (!this.boxWidth) {
          this.mergedWidth = this.width
        }
      }
    },
    boxWidth:{
      deep:true,
      immediate:true,
      handler(value) {
        if (value) {
          this.mergedWidth = value
        }
      }
    }
  },
  mounted() {
    const {mergeColor}=this
    mergeColor()
  }
}
</script>

<style lang="less">
  .border-box-2{
    position: relative;
    width: 100%;
    height: 100%;

    .border-svg-container{
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0px;
      left: 0px;
    }
    .border-box-content{
      position: relative;
      width: 100%;
      height: 100%;
      padding: 10px;
      padding-right: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/border/border-box-2/main.vue